import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

// get projects for show on admin dashboard

export const getAdOneQuatation = createAsyncThunk(
    "/admin/get-admin-one-quotation",
    async (payload) => {
        try {
            const myurl = `${V_URL}/believe/get-one-quotation/${payload}`;

            const response = await axios({
                method: "get",
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });

            const data = response.data;
            // console.log(data, "adminGetEmployee response");

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const initialState = {
    user: null,
    loading: false,
    error: null,
};

const getAdOneQuatationSlice = createSlice({
    name: "getAdOneQuatation",
    initialState,
    reducers: {
        resetGetAdOneQuatation: (state) => {
            state.user = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAdOneQuatation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAdOneQuatation.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getAdOneQuatation.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetGetAdOneQuatation } = getAdOneQuatationSlice.actions;

export default getAdOneQuatationSlice.reducer;
